import actions from '@/core/store/pedido/documentos/processo-digital/actions'
import desentranhamentoPedido from '@/core/store/pedido/documentos/processo-digital/desentranhamento'

export default {
	actions,
	modules: {
		desentranhamentoPedido,
	},
}
